<template>
  <div class="c-message c-message--generic c-content" data-message-type="generic">
    <div class="c-message__content" v-html="output"></div>
  </div>
</template>

<script>
export default {
  name: "Generic",
  props: ['content'],
  data() {
    return {
      output: ''
    }
  },
  mounted() {
    this.renderContent()
  },
  methods: {
    renderContent() {
      this.output = this.content.message
    }
  }
}
</script>
